// AnnePayiTablosu — Anne Defteri'nde audit toggle açıkken görünen fon ×
// anne_oran × units × gross tablosu. Inline ⚠ chip her satırda satır içi
// bağlam verir (CR2-10).

import { fmtNum } from "../lib/format";
import InlineAnomalyChip from "./InlineAnomalyChip";
import type { Anomaly, MotherLedgerRow } from "../types/api";

interface Props {
  rows: MotherLedgerRow[];
  openAnomalies: Anomaly[];
  totalTl: number;
}

function formatAnneOran(n: number): string {
  // 0.221 → "%22,1"
  const pct = (n * 100).toFixed(1).replace(".", ",");
  return `%${pct}`;
}

export default function AnnePayiTablosu({ rows, openAnomalies, totalTl }: Props) {
  const fundsWithAnomalies = new Set(openAnomalies.map((a) => a.fund));
  const anyAnomaly = rows.some((r) => fundsWithAnomalies.has(r.fund));

  return (
    <article className="rounded-xl bg-ink-800/60 border border-ink-700 p-3 mt-2">
      <table className="w-full text-[12px]">
        <thead>
          <tr className="text-ink-400 text-[10px] uppercase tracking-wider">
            <th className="text-left font-medium py-1.5">Fon</th>
            <th className="text-right font-medium py-1.5">anne_oran</th>
            <th className="text-right font-medium py-1.5">units</th>
            <th className="text-right font-medium py-1.5">gross TL</th>
          </tr>
        </thead>
        <tbody className="fon-dili">
          {rows.map((r) => {
            const anomalies = openAnomalies.filter((a) => a.fund === r.fund);
            return (
              <tr key={r.fund} className="border-t border-ink-700/60">
                <td className="py-1.5 text-ink-200">
                  {r.fund}
                  {anomalies.length > 0 && (
                    <span className="ml-1 align-middle">
                      <InlineAnomalyChip
                        fund={r.fund}
                        anomalies={anomalies}
                        size={8}
                      />
                    </span>
                  )}
                </td>
                <td className="py-1.5 text-right text-ink-200">
                  {formatAnneOran(r.anne_oran)}
                </td>
                <td className="py-1.5 text-right text-ink-300">
                  {fmtNum(r.units)}
                </td>
                <td className="py-1.5 text-right text-ink-200">
                  {fmtNum(r.gross_tl)}
                </td>
              </tr>
            );
          })}
        </tbody>
        <tfoot>
          <tr className="border-t border-ink-600">
            <td
              className="pt-2 text-ink-300 text-[11px]"
              colSpan={3}
            >
              Toplam pay
            </td>
            <td className="pt-2 text-right text-accent-300 fon-dili font-semibold">
              {fmtNum(totalTl)}
            </td>
          </tr>
        </tfoot>
      </table>
      {anyAnomaly && (
        <p className="hedef-dili text-ink-300 text-[11px] mt-3 leading-snug">
          ⚠ iki fonda açık veri uyarısı var — bu satırların gross değeri
          tahmin içerebilir.
        </p>
      )}
    </article>
  );
}
